import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { ReceptionServiceFormController } from '../../../../ReceptionServiceForm';
import {
   ReceptionServicePractitionerPriceRangeChecked,
   ReceptionServicePractitionerValue,
} from '../../receptionServicePractitioner.types';

type ReceptionServicePractitionerPriceRangeCheckedCellProps = InteractiveTableCellProps<ReceptionServicePractitionerPriceRangeChecked> &
   Pick<ReceptionServiceFormController, 'control'>;

export const ReceptionServicePractitionerPriceRangeCheckedCell = (
   props: ReceptionServicePractitionerPriceRangeCheckedCellProps
): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<ReceptionServicePractitionerValue>();
   const usingDefaultConfiguration = getCellValue('usingDefaultConfiguration', props.index);

   return (
      <InteractiveTable.CheckboxCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
         disabled={usingDefaultConfiguration}
      />
   );
};
